import {
  FETCH_DWK_PROPCOMS,
  FETCH_DWK_PROPCOM,
  SEARCH_DWK_PROPCOMS,
  FETCHING_DWK_PROPCOMS,
} from '../actions/types';

const INITIAL_STATE = { 
  city:'', 
  fetching:true,
  fetchingCS:true,
  fetchingCR:true,
  propcomsMy: [],
  propcomsCS: [],
  propcomsCR: [],
  propcom: null, 

  offsetCS: 0, 
  offsetCR: 0,
  offsetCRSH: 0,
  offsetCSSH: 0,   //for shortlist

  limitCS: 20,
  limitCR: 20,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case FETCH_DWK_PROPCOMS:
      return { ...state, ...action.payload };
    case FETCH_DWK_PROPCOM:
      return { ...state, propcom: action.payload };
    
    case SEARCH_DWK_PROPCOMS:
      
      return { ...state, ...action.payload };
    
    case FETCHING_DWK_PROPCOMS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
